import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './main.component';
import { PaymentComponent } from './payment/payment.component';
import { StartDemoComponent } from './start-demo/start-demo.component';
import { ListaNoticiasComponent } from './lista-noticias/lista-noticias.component';
import { ListaEventosComponent } from './lista-eventos/lista-eventos.component';
import { HomeComponent } from './home/home.component';
import { PlansComponent } from '../pre-auth/plans/plans.component';
import { ProjectsComponent } from '../pre-auth/projects/projects.component';
import { ContactComponent } from '../pre-auth/contact/contact.component';
import { ConfirmationPaymentComponent } from './confirmation-payment/confirmation-payment.component';
import { PrePaymentComponent } from '../pre-auth/pre-payment/pre-payment.component';
import { AuthGuard } from 'src/app/core/guards/auth/auth.guard';
import { AccountComponent } from './account/account.component';
import { SelectPageComponent } from './select-page/select-page.component';
import { CheckLoginGuard } from 'src/app/core/guards/auth/check-login.guard';
import { HomeAuthComponent } from './home-auth/home-auth.component';
import { StatisticsComponent } from './statistics/statistics.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'auth', component: HomeAuthComponent },
  {
    path: 'auth/select-page/:id_evento/:tipo_evento',
    component: SelectPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'auth/stats',
    component: StatisticsComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'auth/plans',
    component: PlansComponent,
    // canActivate: [CheckLoginGuard],
  },
  {
    path: 'auth/projects',
    component: ProjectsComponent,
    // canActivate: [CheckLoginGuard],
  },
  {
    path: 'auth/contact',
    component: ContactComponent,
    // canActivate: [CheckLoginGuard],
  },

  {
    path: 'auth/account',
    component: AccountComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'auth/start-demo',
    component: StartDemoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'auth/news',
    component: ListaNoticiasComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'auth/events',
    component: ListaEventosComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'auth/projects',
    component: ProjectsComponent,
    canActivate: [AuthGuard],
  },
  { path: 'auth/home', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'auth/plans', component: PlansComponent, canActivate: [AuthGuard] },
  {
    path: 'auth/contact',
    component: ContactComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'auth/pre-payment',
    component: PrePaymentComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'auth/payment',
    component: PaymentComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'auth/confirmation-payment',
    component: ConfirmationPaymentComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainRoutingModule {}
